import { useUpdateMedComplexMutation } from '@/api'
import { Input } from '@/components'
import { useModal } from '@/hooks'
import { ModalType } from '@/store/app'
import {
  Box,
  Button,
  Checkbox,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { MedComplexContext } from '../../MedComplex'
import { Accordion } from '../../components'
import { CheckMarkIcon, ResetIcon } from '../../icons'
import { styles } from '../../styles'
import type { SwitchItem } from './types'
import { switchStyle } from './styles'

export const SettingsInfo = () => {
  const { medcomplex, refetch } = useContext(MedComplexContext)
  const { showModal } = useModal()
  const [updateMedComplex] = useUpdateMedComplexMutation()

  const [switches, setSwitches] = useState<SwitchItem[]>([
    {
      field: 'record_slides',
      off_title: 'Видео',
      on_title: 'GIF',
      value: medcomplex?.record_slides,
    },
  ])

  const switchHandle = (index: number) => {
    const arr = switches
    arr[index].value = !arr[index].value
    setSwitches([...arr])
    updateMedComplex({
      id: medcomplex?.id,
      payload: {
        ...JSON.parse(`{"${arr[index].field}":${arr[index].value}}`),
      },
    }).then(() => refetch())
    showModal(ModalType.MEDCOMPLEX_COMPLETE_CONFIG)
  }

  return (
    <Stack gap={'8px'}>
      {/* <Box sx={{ marginLeft: 'auto' }}>
        <Stack direction={'row'} gap={'12px'}>
          <Button variant="outlined" onClick={handleResetConfig}>
            <Stack direction={'row'} gap={'4px'} sx={{ marginBottom: '-4px' }}>
              <ResetIcon />
              Сброс
            </Stack>
          </Button>
          <Button
            variant="contained"
            type="submit"
            onClick={onSubmit}
            // disabled={!watchConfig.every((item: string) => Boolean(item))}
          >
            <Stack direction={'row'} gap={'4px'} sx={{ marginBottom: '-4px' }}>
              <CheckMarkIcon />
              Применить параметры
            </Stack>
          </Button>
        </Stack>
      </Box> */}
      <Accordion title={'Видео'} defaultExpanded>
        <TableContainer>
          <Table sx={styles.table}>
            <TableBody>
              {switches?.map((e: SwitchItem, i: number) => (
                <TableRow key={i}>
                  <TableCell sx={{ verticalAlign: 'middle' }}>
                    <Stack direction={'row'} gap={'12px'} alignItems={'center'}>
                      <Box
                        sx={{
                          overflow: 'hidden',
                          wordWrap: 'break-word',
                          fontSize: '16px',
                          fontWeight: '400',
                        }}
                      >
                        {e?.off_title}
                      </Box>
                      <Switch
                        checked={e.value}
                        onChange={() => switchHandle(i)}
                        inputProps={{ 'aria-label': 'controlled' }}
                        sx={switchStyle}
                      />
                      <Box
                        sx={{
                          overflow: 'hidden',
                          wordWrap: 'break-word',
                          fontSize: '16px',
                          fontWeight: '400',
                        }}
                      >
                        {e?.on_title}
                      </Box>
                    </Stack>
                  </TableCell>
                  <TableCell sx={{ verticalAlign: 'middle' }}></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Accordion>
    </Stack>
  )
}
